'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearAfter;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/yearAfter.js
// module id = 394
// module chunks = 1